export const addTrailingSlash = (slug) => {
  if (slug.includes('?') && slug[slug.indexOf('?') - 1] !== '/') {
    return (
      slug.substring(0, slug.indexOf('?')) +
      '/' +
      slug.substring(slug.indexOf('?'), slug.length)
    );
  }
  if (slug.includes('#') && slug[slug.indexOf('#') - 1] !== '/') {
    return (
      slug.substring(0, slug.indexOf('#')) +
      '/' +
      slug.substring(slug.indexOf('#'), slug.length)
    );
  }
  if (slug.includes('#') && slug[slug.indexOf('#') - 1] === '/') {
    return slug;
  }

  return slug[slug.length - 1] === '/' ? slug : slug.concat('/');
};

export const isYoutubeLink = (link) => {
  const regExp =
    /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
  return link.match(regExp);
};

const isExternalUrl = (str) => {
  const isExternalReg = /^(http|https|mailto)/;
  if (!str) {
    return true;
  }
  if (str.includes('slp')) {
    return true;
  }
  return isExternalReg.test(String(str).toLowerCase()) ? true : false;
};

export const isExternalUrlhref = (str) => {
  const isExternalReg = /^(http|https|mailto|#|tel)/;
  if (!str) {
    return true;
  }

  return isExternalReg.test(String(str).toLowerCase()) ? true : false;
};

export default isExternalUrl;

export const isSmallDevice = () =>
  typeof window !== 'undefined' && window.innerWidth < 992;

// Parses an optional contact-name token from a phone field.
// "{{Austin King}}867-446-6432" -> { name: 'Austin King', number: '867-446-6432' }
// "867-446-6432"                -> { name: null, number: '867-446-6432' }
// Keeps the tel: link callable by returning only the number portion.
export const parsePhoneContact = (phone) => {
  if (!phone) {
    return { name: null, number: '' };
  }
  const match = String(phone).match(/^\s*\{\{\s*(.+?)\s*\}\}\s*(.*)$/s);
  if (match) {
    return { name: match[1].trim(), number: match[2].trim() };
  }
  return { name: null, number: String(phone).trim() };
};
